module.exports = __webpack_public_path__ + "static/media/steve.ba7cc079.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/pic/steve.PNG
// module id = 1430
// module chunks = 0